import { HttpInterceptorFn } from '@angular/common/http';
import { inject } from '@angular/core';
import { finalize } from 'rxjs';
import { SpinnerTailService } from '../services/spinner-tail.service';

export const spinnerInterceptor: HttpInterceptorFn = (req, next) => {
  const spinner = inject(SpinnerTailService);

  if (!req.headers.has('ignoreSpinner')) {
    spinner.show();
  }

  const headers = req.headers.delete('ignoreSpinner');

  req = req.clone({
    headers,
  });

  return next(req).pipe(finalize(() => spinner.hide()));
};
